import { useState, useEffect, useRef } from "react";
import { Command } from "cmdk";
import { api } from "@/lib/api";
import { MonitorSmartphone, Building2, Ticket, ArrowRight, Sparkles, LayoutDashboard, BellRing, User } from "lucide-react";

const QUICK = [
  { label: "Go to Dashboard", path: "/dashboard", icon: LayoutDashboard },
  { label: "Go to Devices", path: "/devices", icon: MonitorSmartphone },
  { label: "Go to Alerts", path: "/alerts", icon: BellRing },
  { label: "Go to Customers", path: "/customers", icon: Building2 },
];

export function CommandPalette({ open, setOpen, onNavigate, onCopilot }) {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const timer = useRef();

  useEffect(() => {
    if (!open) { setQ(""); setResults([]); }
  }, [open]);

  useEffect(() => {
    clearTimeout(timer.current);
    if (!q) { setResults([]); return; }
    timer.current = setTimeout(() => {
      api.get(`/search?q=${encodeURIComponent(q)}`).then((r) => setResults(r.data)).catch(() => setResults([]));
    }, 200);
  }, [q]);

  if (!open) return null;
  const go = (path) => { setOpen(false); onNavigate(path); };
  const ICON = { device: MonitorSmartphone, customer: Building2, ticket: Ticket, person: User };
  const PATH = { device: "/devices/", customer: "/customers/", ticket: "/tickets/", person: "/people/" };

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center pt-[12vh] bg-black/60 backdrop-blur-sm"
         onClick={() => setOpen(false)}>
      <div className="w-full max-w-xl mx-4" onClick={(e) => e.stopPropagation()}>
        <Command className="rounded-xl border border-slate-700 overflow-hidden shadow-2xl" style={{ background: "#121824" }}>
          <div className="border-b border-slate-800">
            <Command.Input data-testid="command-palette-input" value={q} onValueChange={setQ} autoFocus
              placeholder="Search devices, people, customers, tickets… or type a command"
              className="w-full bg-transparent px-4 py-3.5 text-sm text-slate-100 outline-none placeholder:text-slate-500" />
          </div>
          <Command.List className="max-h-80 overflow-y-auto p-2">
            <Command.Empty className="py-6 text-center text-sm text-slate-500">No results.</Command.Empty>
            {results.length > 0 && (
              <Command.Group heading="Results" className="text-[10px] uppercase tracking-wider text-slate-500 px-2 py-1">
                {results.map((r) => {
                  const Ic = ICON[r.type] || ArrowRight;
                  return (
                    <Command.Item key={r.type + r.id} value={`${r.label} ${r.sub || ""} ${r.id}`} onSelect={() => go(PATH[r.type] + r.id)}
                      className="flex items-center gap-3 rounded-md px-2.5 py-2 text-sm text-slate-200 cursor-pointer data-[selected=true]:bg-slate-800">
                      <Ic size={15} className="text-cyan-400" />
                      <span className="flex-1">{r.label}</span>
                      <span className="text-[11px] text-slate-500 font-mono">{r.sub}</span>
                    </Command.Item>
                  );
                })}
              </Command.Group>
            )}
            <Command.Group heading="Navigate" className="text-[10px] uppercase tracking-wider text-slate-500 px-2 py-1 mt-1">
              {QUICK.map((n) => (
                <Command.Item key={n.path} value={n.label} onSelect={() => go(n.path)}
                  className="flex items-center gap-3 rounded-md px-2.5 py-2 text-sm text-slate-200 cursor-pointer data-[selected=true]:bg-slate-800">
                  <n.icon size={15} className="text-slate-400" /> {n.label}
                </Command.Item>
              ))}
              <Command.Item value="ask copilot" onSelect={() => { setOpen(false); onCopilot(); }}
                className="flex items-center gap-3 rounded-md px-2.5 py-2 text-sm text-slate-200 cursor-pointer data-[selected=true]:bg-slate-800">
                <Sparkles size={15} className="text-cyan-400" /> Ask mimoIT Control Copilot
              </Command.Item>
            </Command.Group>
          </Command.List>
        </Command>
      </div>
    </div>
  );
}
